import { z } from 'zod';

export const NotifyMassNotificationScalarFieldEnumSchema = z.enum(['id','cityId','createdAt','updatedAt','startedAt','completedAt','channelType','total','notifyContentId','billingTransactionId']);

export default NotifyMassNotificationScalarFieldEnumSchema;
